import { useRef, useState } from "react";
import Ticket from "./Ticket";
import { Button } from "primereact/button";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import LaserPrint from "./LaserPrint";
import DotMatrixPrint from "./DotMatrixPrint";
import PosPrint from "./PosPrint";
import ThermalPrint from "./ThermalPrint";
import { trackPrint } from "../../../../services/print.service";
import RadioButtonGroup from "../Modals/SeatConfirmation/RadioButtonGroup";
import { useToast } from "../../../../hooks/ToastContext";
import { getErrorMessage } from "../../helpers/booking-helper";

const TicketView = ({ data, isPassengerPartMiddle, closeDialog }) => {
    const [printer, setPrinter] = useState(
        localStorage.getItem("printer_type") || "Laser"
    );
    const [printedTime, setPrintedTime] = useState(new Date().toString());

    const dotMatrixPrint = useRef(null);
    const laserPrint = useRef(null);
    const posPrint = useRef(null);
    const thermalPrint = useRef(null);

    const { toast } = useToast();

    const reactToPrintFn = useReactToPrint({
        content: () => {
            if (printer === "Dot-Matrix") return dotMatrixPrint.current;
            else if (printer === "Thermal") return thermalPrint.current;
            else if (printer === "POS") return posPrint.current;
            else return laserPrint.current;
        },
        onAfterPrint: closeDialog,
    });

    const checkAndPrint = async () => {
        try {
            const response = await trackPrint({
                ticket_number: data?.ticketNumber,
                pnr: data?.pnr,
                trip_number: data?.tripNumber,
            });

            if (response?.status == 200) {
                setPrintedTime(new Date().toString());
                reactToPrintFn();
            } else {
                toast.error({
                    detail: "No more printing allowed!",
                });
            }
        } catch (e) {
            console.log(e);

            toast.error({
                detail: getErrorMessage(e),
            });
        }
    };

    return (
        <div className="relatve">
            <div className="flex flex-col">
                {data?.status === "booked" ? (
                    <div className="absolute top-[50%] left-[40%] opacity-20">
                        <h1 className="text-3xl font-bold text-red-600">
                            BOOKED TICKET
                        </h1>
                    </div>
                ) : (
                    <div className="flex flex-row justify-between mt-4">
                        <RadioButtonGroup
                            printer={printer}
                            setPrinter={setPrinter}
                        />
                        {data?.allowedToPrint ? (
                            <Button
                                label="Print"
                                severity="danger"
                                size="small"
                                className="px-2 py-1"
                                onClick={checkAndPrint}
                            />
                        ) : null}
                        <div className="hidden">
                            <LaserPrint
                                data={data}
                                isPassengerPartMiddle={isPassengerPartMiddle}
                                ref={laserPrint}
                                printedTime={printedTime}
                            />
                            <DotMatrixPrint
                                data={data}
                                ref={dotMatrixPrint}
                                printedTime={printedTime}
                            />
                            <ThermalPrint
                                data={data}
                                ref={thermalPrint}
                                printedTime={printedTime}
                            />
                            <PosPrint
                                data={data}
                                ref={posPrint}
                                printedTime={printedTime}
                            />
                        </div>
                    </div>
                )}
                <Ticket
                    data={data}
                    isPassengerPartMiddle={isPassengerPartMiddle}
                    ref={null}
                    printedTime={printedTime}
                />
            </div>
        </div>
    );
};

export default TicketView;
